// Reads the game's current move count from the shared puzzle header. The old
// `.puzzle-header__moves` element was removed from the UI on purpose, so the
// count now rides invisibly on the header root as `data-move-count` (set from
// the `moveCount` prop — no visual element). Used to gate the undo penalty:
// no penalty until the player has made at least PENALTY_FREE_MOVES moves.
export const PENALTY_FREE_MOVES = 6

export function readMoveCount(container: HTMLElement | null): number {
  if (container === null) return 0
  const header = container.querySelector(".puzzle-header")
  const parsed = Number(header?.getAttribute("data-move-count") ?? "")
  return Number.isFinite(parsed) ? parsed : 0
}